import { Component, HostListener, OnInit } from '@angular/core';
import { User } from 'src/app/shared/models/security/user';
import {
	ModuleSAE,
	Parcours
} from 'src/app/shared/models/services-aide-emploi/parcours';
import { SortOrder } from '../../beneficiaires/detail-beneficiaire/detail-beneficiaire.component';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { Observable, Subject, debounceTime, of } from 'rxjs';
import { FacadeService } from 'src/app/core/services/facade.service';
import { Params, Router } from '@angular/router';
import { LogService } from 'src/app/core/services/log/log.service';
import { ErrorResponse } from 'src/app/shared/models/api-response/error-response';
import { SerieModalAjoutFormComponent } from '../../formations/modal/serie-modal-ajout-form/serie-modal-ajout-form.component';
import { ModuleDetailModalComponent } from '../module-detail-modal/module-detail-modal.component';

@Component({
	selector: 'app-list-parcours',
	templateUrl: './list-parcours.component.html',
	styleUrls: ['./list-parcours.component.scss']
})
export class ListParcoursComponent implements OnInit {
	parcours: Parcours[];

	user: User = null;

	isAddable = false;
	isImportable = false;
	isExportable = false;

	sortType = 'name';
	sortOrder: SortOrder = 'asc';
	searchedInput: string = '';

	ajoutParcoursModalref: BsModalRef;

	// nombre de page totale pour la pagination
	currentPage = 1;
	itemsPerPage = 10;

	isMobile = false;
	screenWidth: number;

	isListingLoading: boolean = true;
	firstTimeLoading: boolean = true;

	hoveredModule: ModuleSAE | null = null;

	filteredParcours: Parcours[] = [];
	selectedService: string | null = null;
	selectedModuleType: string | null = null;

	ajoutFormationModalref: BsModalRef;

	private searchSubject = new Subject<string>();

	selectedPlanningState: 'ALL' | 'PLANNED' | 'UNPLANNED' = 'ALL';

	constructor(
		private facade: FacadeService,
		private router: Router,
		private logger: LogService,
		private modalService: BsModalService
	) {}

	@HostListener('window:resize', ['$event'])
	onWindowResize() {
		this.screenWidth = window.innerWidth;
		if (this.screenWidth < 1200) {
			this.isMobile = true;
		} else {
			this.isMobile = false;
		}
	}

	onActivate(event) {
		window.scroll(0, 0);
	}

	ngOnInit(): void {
		this.screenWidth = window.innerWidth;
		this.isMobile =
			this.facade.mobileService.isMobile() || this.screenWidth < 1200;

		this.user = this.facade.dataStorageService.getUser();
		if (this.facade.dataStorageService.isPlanificatrice()) {
			this.isImportable = false;
			this.isExportable = false;
		}
		if (
			this.facade.dataStorageService.isProjectManager() ||
			this.facade.dataStorageService.isPlanificatrice()
		) {
			this.isAddable = false;
		}
		this.getParcours();
	}

	getParcours(): void {
		this.isListingLoading = true;

		this.facade.parcoursService.getParcours().subscribe({
			next: (parcours: Parcours[]) => {
				this.parcours = parcours;
				this.filteredParcours = [...this.parcours]; // initialisation
			},
			error: (err: ErrorResponse) => {
				this.facade.toastService.createHttpErrorToast(
					err.error.response ? err.error.response : '',
					err.status
				);
				this.logger.error(
					'' + err.status + ' ' + err.error.response ? err.error.response : ''
				);
			},
			complete: () => {
				this.isListingLoading = false;
			}
		});
	}

	moduleTooltip(module: ModuleSAE): string {
		return module.missions?.length
			? `${module.missions.length} mission(s)`
			: 'Aucune mission';
	}

	selectParcours(parcours: Parcours): void {
		const link = ['/parcours', parcours.id];
		this.router.navigate(link);
	}

	// importMissionPlaces(event: any): void {
	// 	this.isImportable = false;
	// 	this.logger.log('Import de missionPlace');
	// 	this.missionPlaceCsvFile = event.target.files[0];
	// 	this.facade.missionPlaceService
	// 		.importMissionPlaces(this.missionPlaceCsvFile)
	// 		.subscribe({
	// 			complete: () => {
	// 				this.logger.log("C'est importé !");
	// 				this.getMissionPlace();
	// 				this.isImportable = true;
	// 			},
	// 			error: (err: ErrorResponse) => {
	// 				this.isImportable = true;
	// 				this.logger.log("C'est PAS importé !", err);
	// 				this.facade.toastService.createHttpErrorToast(
	// 					err.error.response ? err.error.response : '',
	// 					err.status
	// 				);
	// 			}
	// 		});
	// }

	// exportMissionPlaces(): void {
	// 	this.facade.exportService
	// 		.exportMissionPlaces()
	// 		.subscribe((blob) => saveAs(blob, 'missionPlaces.csv'));
	// }

	openModalAjout() {
		// 	this.ajoutMissionPlaceModalref = this.modalService.show(
		// 		MissionPlaceModalAjoutFormComponent,
		// 		{
		// 			class: 'modal-lg',
		// 			backdrop: 'static'
		// 		}
		// 	);
		// 	this.ajoutMissionPlaceModalref.onHide.subscribe((reason: string | any) => {
		// 		this.getMissionPlace();
		// 	});
	}

	onModuleClick(module: ModuleSAE, parcours: Parcours): void {
		if (!module.missions || module.missions.length === 0) {
			const queryParams: Params = {
				start: module.startDate,
				end: module.endDate,
				hours: module.plannedDuration,
				missionType: module.type,
				beneficiaireId: parcours.beneficiaire.id,
				idDemandDH: parcours.idDemandDH,
				serviceName: parcours.service.name,
				intervenantId: module.intervenant.id
			};

			this.openModalAjoutSerie(of(queryParams));
		} else if (module.missions.length > 0) {
			this.openModuleDetailModal(parcours, module);
		}
	}

	openModalAjoutSerie(queryParams?: Observable<Params>) {
		const initialState: any = {};

		if (queryParams) {
			queryParams.subscribe((params) => {
				initialState.parameters = {
					start: params['start'],
					end: params['end'],
					hours: params['hours'],
					missionType: params['missionType'],
					beneficiaireId: params['beneficiaireId'],
					idDemandDH: params['idDemandDH'],
					serviceName: params['serviceName'],
					intervenantId: params['intervenantId']
				};

				this.ajoutFormationModalref = this.modalService.show(
					SerieModalAjoutFormComponent,
					{
						class: 'modal-lg',
						initialState,
						backdrop: 'static'
					}
				);

				this.ajoutFormationModalref.onHide.subscribe(() => {
					this.getParcours();
				});
			});
		}
	}

	openModuleDetailModal(parcours: Parcours, module: ModuleSAE): void {
		this.modalService.show(ModuleDetailModalComponent, {
			class: 'modal-lg',
			initialState: {
				parcours: parcours,
				module: module
			}
		});
	}

	/**
	 * Fonction pour les paramètres de trie. Si le string choisi vaut le string courant l'on change l'ordre de trie (croissant/décroissant)
	 * sinon l'on chance la colonne de trie et l'on trie par ordre crosisant
	 * @param str colonne de trie
	 */
	sortChange(str: string): void {
		if (str === this.sortType) {
			if (this.sortOrder === 'asc') {
				this.sortOrder = 'desc';
			} else {
				this.sortOrder = 'asc';
			}
		} else {
			this.sortType = str;
			this.sortOrder = 'asc';
		}
	}

	filterParcours(): void {
		this.filteredParcours = this.parcours.filter((p) => {
			const matchService =
				!this.selectedService || p.service?.name === this.selectedService;

			const matchModuleType =
				!this.selectedModuleType ||
				(p.modules || []).some((m) => m.type === this.selectedModuleType);

			const matchPlanningState =
				this.selectedPlanningState === 'ALL' ||
				(this.selectedPlanningState === 'PLANNED' &&
					(p.modules || []).some((m) => m.missions && m.missions.length > 0)) ||
				(this.selectedPlanningState === 'UNPLANNED' &&
					(p.modules || []).some(
						(m) => !m.missions || m.missions.length === 0
					));

			const search = this.searchedInput?.toLowerCase() || '';
			const matchText =
				!search ||
				p.idDemandDH?.toLowerCase().includes(search) ||
				p.beneficiaire?.firstName?.toLowerCase().includes(search) ||
				p.beneficiaire?.lastName?.toLowerCase().includes(search);

			return matchService && matchModuleType && matchPlanningState && matchText;
		});
	}

	importFromOcashe() {
		this.isListingLoading = true; // Si tu as un loader
		this.facade.parcoursService.importParcoursFromOcashe().subscribe({
			next: (result) => {
				this.getParcours(); // À adapter avec ta méthode de reload
			},
			error: (err) => {
				this.logger.error(err);
			},
			complete: () => {
				// this.isLoading = false;
			}
		});
	}

	get availableServices(): string[] {
		return [
			...new Set(this.parcours?.map((p) => p.service?.name).filter(Boolean))
		];
	}

	get availableModuleTypes(): string[] {
		return [
			...new Set(
				this.parcours
					?.flatMap((p) => p.modules || [])
					.map((m) => m.type)
					.filter(Boolean)
			)
		];
	}
}
